"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _index = _interopRequireDefault(require("../mobileConfigRight/index.js"));
var _index2 = _interopRequireDefault(require("../rightBtn/index.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'c_recommend',
  componentsName: 'recommend',
  cname: '推荐',
  props: {
    activeIndex: {
      type: null
    },
    num: {
      type: null
    },
    index: {
      type: null
    }
  },
  components: _objectSpread(_objectSpread({}, _index.default), {}, {
    rightBtn: _index2.default
  }),
  data: function data() {
    return {
      configObj: {},
      // 配置对象
      rCom: [{
        components: _index.default.c_checked_tab,
        configNme: 'setUp'
      }] // 当前页面组件
    };
  },
  watch: {
    num: function num(nVal) {
      var value = JSON.parse(JSON.stringify(this.$store.state.mobildConfig.defaultArray[nVal]));
      this.configObj = value;
    },
    configObj: {
      handler: function handler(nVal) {
        this.$store.commit('mobildConfig/UPDATEARR', {
          num: this.num,
          val: nVal
        });
      },
      deep: true
    },
    'configObj.setUp.tabVal': {
      handler: function handler(nVal) {
        var arr = [this.rCom[0]];
        if (nVal == 0) {
          // 内容设置
          var tempArr = [
          // 卡片1
          {
            components: _index.default.c_title,
            configNme: 'card1Img'
          }, {
            components: _index.default.c_upload_img,
            configNme: 'card1Img'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1Title'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1Tag'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1SubTitle'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1GoodsName'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1Desc1'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1Desc2'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card1Link'
          },
          // 卡片2
          {
            components: _index.default.c_title,
            configNme: 'card2Img'
          }, {
            components: _index.default.c_upload_img,
            configNme: 'card2Img'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card2Title'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card2SubTitle'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card2Tag'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card2Link'
          },
          // 卡片3
          {
            components: _index.default.c_title,
            configNme: 'card3Img'
          }, {
            components: _index.default.c_upload_img,
            configNme: 'card3Img'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card3Title'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card3SubTitle'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card3Tag'
          }, {
            components: _index.default.c_input_item,
            configNme: 'card3Link'
          }];
          this.rCom = arr.concat(tempArr);
        } else {
          // 样式设置
          var _tempArr = [{
            components: _index.default.c_title,
            configNme: 'card1BgColor'
          }, {
            components: _index.default.c_bg_color,
            configNme: 'card1BgColor'
          }, {
            components: _index.default.c_bg_color,
            configNme: 'card2BgColor'
          }, {
            components: _index.default.c_bg_color,
            configNme: 'card3BgColor'
          }];
          this.rCom = arr.concat(_tempArr);
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var value = JSON.parse(JSON.stringify(_this.$store.state.mobildConfig.defaultArray[_this.num]));
      _this.configObj = value;
    });
  },
  methods: {
    getConfig: function getConfig() {}
  }
};